import { Chart } from 'chart.js/auto';

import { createAnnualCashflowsChart } from '../graphs/annual_cash_flows_chart'

$(function() {
  const $canvas = $('#annualCashFlowsChartCanvas');
  if (!$canvas.length) return;

  const annualScope = 'global';
  const localStorageKey = 'fund' + $canvas.data('fund-id') + 'GraphData';

  if (!!localStorage.getItem(localStorageKey)) {
    createAnnualCashflowsChart(JSON.parse(localStorage.getItem(localStorageKey)), annualScope);
  }

  $.ajax({
    url: $canvas.data('target'),
    type: 'GET',
    dataType: 'json',
    success: function (data) {
      localStorage.setItem(localStorageKey, JSON.stringify(data));

      let existingAnnualChart = Chart.getChart('annualCashFlowsChartCanvas');

      if (!!existingAnnualChart) {
        existingAnnualChart.destroy();
      };

      createAnnualCashflowsChart(JSON.parse(localStorage.getItem(localStorageKey)), annualScope);
    },
    error: function () {
      console.error;
    }
  });

  setTimeout(function() { $('[data-bs-toggle="tooltip"]').tooltip() }, 100)
});
